import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function EmailPopupModal() {
    const [isOpen, setIsOpen] = useState(true);
    const [agree, setAgree] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const link = document.createElement('link');
        link.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap';
        link.rel = 'stylesheet';
        document.head.appendChild(link);

        document.body.style.fontFamily = '"Poppins", sans-serif';

        const timer = setTimeout(() => {
            setIsOpen(true);
        }, 1000);

        return () => {
            clearTimeout(timer);
            document.head.removeChild(link);
        };
    }, []);

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleOutsideClick = (event) => {
        if (event.target.id === "emailModal") {
            setIsOpen(false);
        }
    };

      // Redirect to terms page if user has not agreed before
      useEffect(() => {
        const agreed = localStorage.getItem("agreedToTerms");
        if (agreed === "true") {
          setIsOpen(false);
          navigate("/home");
        }
      }, [navigate]);


    const handleAgree = () => {
        if (agree) {
          localStorage.setItem("agreedToTerms", "true");
          setIsOpen(false);
          navigate("/home"); // redirect only if checkbox is checked
        } else {
          alert("Please agree to the Privacy Policy and Terms before continuing.");
        }
      };
    
      if (!isOpen) return null;

    return (
        <div
            id="emailModal"
            style={{
                ...modalStyle,
                display: isOpen ? 'flex' : 'none',
            }}
            // onClick={handleOutsideClick}
        >
            <div className="modal-content" style={modalContentWithBackground} onClick={e => e.stopPropagation()}>
                <div style={overlayBackground}></div>
                {/* <span style={closeStyle} onClick={handleClose}>&times;</span> */}
                <div style={termsContainerStyle}>
                    <h2 style={{ fontSize: '22px', marginBottom: '15px' }}>Terms & Conditions</h2>
                    <div style={termsContentStyle}>
                        <p>Data/information provided to us during sign-up / registering or using our Platform such as name, date of birth, address, telephone/mobile number, email ID and/or any such information shared as proof of identity or address. Some of the sensitive personal data may be collected with your consent, such as your bank account or credit/debit card or other payment instrument information or biometric information such as your facial features or physiological information (in order to enable use of certain features when opted for, available on the Platform), all of the above being in accordance with applicable law(s).</p>
                        <p>You always have the option to not provide information, by choosing not to use a particular service or feature on the Platform. We may track your behaviour, preferences, and other information that you choose to provide on our Platform. This information is compiled and analysed on an aggregated basis. We will also collect your information related to your transactions on Platform and such third-party business partner platforms. When such a third-party business partner collects your personal data directly from you, you will be governed by their privacy policies. We shall not be responsible for the third-party business partner’s privacy practices or the content of their privacy policies, and we request you to read their privacy policies prior to disclosing any information.</p>
                        <p>If you receive an email, a call from a person/association claiming to be MAHINCHA IT SOLUTIONS LLP seeking any personal data like debit/credit card PIN, net-banking or mobile banking password, we request you to never provide such information. If you have already revealed such information, report it immediately to an appropriate law enforcement agency.</p>
                        <p><strong>Usage</strong><br />We use personal data to provide the services you request. To the extent we use your personal data to market to you, we will provide you the ability to opt-out of such uses. We use your personal data to assist sellers and business partners in handling and fulfilling orders; enhancing customer experience; resolving disputes; troubleshooting problems; informing you about offers and updates; customizing your experience; detecting and protecting against fraud or criminal activity; enforcing terms; and for research and analysis purposes.  </p>
                        <p><strong>Sharing</strong><br />We may share your personal data within our group entities, corporate entities, and affiliates. These entities may market to you unless you explicitly opt-out. We may disclose data to sellers, service providers (logistics, payment, etc.), or law enforcement, as required to fulfill our services or comply with legal obligations.</p>
                        <p><strong>Security Precautions</strong><br />We adopt reasonable security practices to protect your data. However, data transmission over the internet cannot be guaranteed as completely secure. Users must ensure the protection of their login credentials.</p>
                        <p><strong>Data Deletion and Retention</strong><br />You can delete your account via profile settings. We may delay deletion if there are pending claims or services. Data may be retained in anonymized form for analytics and research, or longer if required by law.</p>
                        <p><strong>Your Rights</strong><br />You may access, rectify, and update your personal data via Platform functionalities.</p>
                        <p><strong>Consent</strong><br />By using the Platform, you consent to the use and processing of your data in accordance with this policy. If you provide data of others, you confirm you have their consent. You can withdraw consent by writing to our Grievance Officer.</p>
                        <p><strong>Changes to this Privacy Policy</strong><br />This Privacy Policy may be updated from time to time. Please check periodically.</p>
                        <p><strong>Refund Policy</strong><br />We are not providing any kind of refund.</p>
                    </div>

                    <div style={{ marginTop: '20px' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <input type="checkbox" checked={agree} onChange={() => setAgree(!agree)} />
                            I agree to the Terms & Conditions
                        </label>

                        <button
                            onClick={handleAgree}
                            style={{
                                ...buttonStyle,
                                backgroundColor: agree ? '#0D4981' : '#999',
                                cursor: agree ? 'pointer' : 'not-allowed',
                                marginTop: '15px',
                            }}
                            disabled={!agree}
                        >
                            Agree & Continue
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

const termsContainerStyle = {
    textAlign: 'left',
    maxHeight: '400px',
    overflowY: 'auto',
    padding: '10px',
    backgroundColor: '#fff',
    borderRadius: '10px',
    marginTop: '20px',
    fontSize: '14px',
    color: '#333',
    lineHeight: '1.6',
};

const termsContentStyle = {
    whiteSpace: 'pre-line',
};

const modalStyle = {
    display: 'flex',
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    alignItems: 'center',
    justifyContent: 'center',
    backdropFilter: 'blur(5px)',
    zIndex: 9999,
};

const modalContentStyle = {
    position: 'relative',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: '15px',
    margin: 'auto',
    padding: '30px',
    width: '80%',
    maxWidth: '600px',
    boxShadow: '0 10px 20px rgba(0,0,0,0.2)',
    textAlign: 'center',
    fontFamily: '"Poppins", sans-serif',
    color: '#333',
    overflow: 'hidden',
};

const modalContentWithBackground = {
    ...modalContentStyle,
    position: 'relative',
    zIndex: 1,
};

const overlayBackground = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: "url('http://i.ibb.co/GvXgsf0b/handyman.png')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    opacity: 0.3,
    zIndex: -1,
};

const closeStyle = {
    position: 'absolute',
    top: '15px',
    right: '15px',
    color: '#000',
    fontSize: '30px',
    cursor: 'pointer',
    transition: 'color 0.3s ease',
};

const buttonStyle = {
    border: 'none',
    color: 'white',
    padding: '12px 20px',
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    width: '100%',
    fontSize: '16px',
    borderRadius: '30px',
    transition: 'background-color 0.3s ease, transform 0.3s ease',
    boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
    fontFamily: '"Poppins", sans-serif',
};
